// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2yOIJ","error":"Textarea_error__2YM8Q","readonly":"Textarea_readonly__1OvNH","disabled":"Textarea_disabled__1aRug"};